import { ROOM_SHAPES } from './room';

export const WALL_TYPES = {
    REGULAR: 'regular',    // Green hatching
    SAFETY: 'safety',      // Black fill
    OTHER: 'other'         // No fill
};


export const WALL_RENDER_PROPERTIES = {
    [WALL_TYPES.REGULAR]: {
        thickness: 1,
        strokeColor: '#4CAF50',
        //fillColor: '#4CAF50',
        fillColor: null,
        //strokePattern: [5, 5],
    },
    [WALL_TYPES.SAFETY]: {
        thickness: 2,
        strokeColor: '#000',
        //fillColor: '#000',
        fillColor: null,
    },
    [WALL_TYPES.OTHER]: {
        thickness: 0.2,
        strokeColor: '#666',
        fillColor: null,
    },
}

export function Wall(startPoint, endPoint, type, doors = [], windows = [], electricityPoints = []) {
    return {
        id: `wall-${Date.now()}`,
        startPoint,
        endPoint,
        type,
        doors: doors ?? [],
        windows: windows ?? [],
        electricityPoints: electricityPoints ?? []
    };
}

export function addDoor(wall, door) {
    return { ...wall, doors: [...(wall.doors?? []) , door] };
}

export function removeDoor(wall, doorId) {
    return { ...wall, doors: wall?.doors?.filter(door => door.id !== doorId) };
}
export function addWindow(wall, window) {
    return { ...wall, windows: [...(wall.windows?? []) , window] };
}
export function removeWindow(wall, windowId) {
    return { ...wall, windows: wall?.windows?.filter(window => window.id !== windowId) };
}
export function addElectricityPoint(wall, electricityPoint) {
    return { ...wall, electricityPoints: [...(wall.electricityPoints?? []) , electricityPoint] };
}

export function removeElectricityPoint(wall, electricityPointId) {
    return { ...wall, electricityPoints: wall?.electricityPoints?.filter(point => point.id !== electricityPointId) };
}
export function updateDoor(wall, updatedDoor) {
    return { ...wall, doors: wall?.doors?.map(door => door.id === updatedDoor.id ? updatedDoor : door) };
}
export function updateWindow(wall, updatedWindow) {
    return { ...wall, windows: wall?.windows?.map(window => window.id === updatedWindow.id ? updatedWindow : window) };
}
export function updateElectricityPoint(wall, updatedElectricityPoint) {
    return { ...wall, electricityPoints: wall?.electricityPoints?.map(point => point.id === updatedElectricityPoint.id ? updatedElectricityPoint : point) };
}


export function createWallsForShape(shape, size) {
    const { width, height } = size;
    const walls = [];

    switch (shape) {
        case ROOM_SHAPES.RECTANGLE:
            // 4 walls forming a rectangle
            walls.push(
                { id: `wall-${Date.now()}-0`, startPoint: { x: 0, y: 0 }, endPoint: { x: width, y: 0 }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-1`, startPoint: { x: width, y: 0 }, endPoint: { x: width, y: height }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-2`, startPoint: { x: width, y: height }, endPoint: { x: 0, y: height }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-3`, startPoint: { x: 0, y: height }, endPoint: { x: 0, y: 0 }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] }
            );
            break;

        case ROOM_SHAPES.L_SHAPE:
            // L-shaped room
            const lWidth = width;
            const lHeight = height;
            const lLeg = Math.min(width, height) * 0.4;
            walls.push(
                { id: `wall-${Date.now()}-0`, startPoint: { x: 0, y: 0 }, endPoint: { x: lWidth, y: 0 }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-1`, startPoint: { x: lWidth, y: 0 }, endPoint: { x: lWidth, y: lLeg }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-2`, startPoint: { x: lWidth, y: lLeg }, endPoint: { x: lWidth - lLeg, y: lLeg }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-3`, startPoint: { x: lWidth - lLeg, y: lLeg }, endPoint: { x: lWidth - lLeg, y: lHeight }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-4`, startPoint: { x: lWidth - lLeg, y: lHeight }, endPoint: { x: 0, y: lHeight }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-5`, startPoint: { x: 0, y: lHeight }, endPoint: { x: 0, y: 0 }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] }
            );
            break;

        case ROOM_SHAPES.U_SHAPE:
            // U-shaped room
            const uWidth = width;
            const uHeight = height;
            const uDepth = Math.min(width, height) * 0.3;
            walls.push(
                { id: `wall-${Date.now()}-0`, startPoint: { x: 0, y: 0 }, endPoint: { x: uWidth, y: 0 }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-1`, startPoint: { x: uWidth, y: 0 }, endPoint: { x: uWidth, y: uHeight }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-2`, startPoint: { x: uWidth, y: uHeight }, endPoint: { x: uWidth - uDepth, y: uHeight }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: []   },
                { id: `wall-${Date.now()}-3`, startPoint: { x: uWidth - uDepth, y: uHeight }, endPoint: { x: uWidth - uDepth, y: uDepth }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-4`, startPoint: { x: uWidth - uDepth, y: uDepth }, endPoint: { x: 0, y: uDepth }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-5`, startPoint: { x: 0, y: uDepth }, endPoint: { x: 0, y: 0 }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] }
            );
            break;

        case ROOM_SHAPES.T_SHAPE:
            // T-shaped room
            const tWidth = width;
            const tHeight = height;
            const tStem = Math.min(width, height) * 0.3;
            walls.push(
                { id: `wall-${Date.now()}-0`, startPoint: { x: 0, y: 0 }, endPoint: { x: tWidth, y: 0 }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-1`, startPoint: { x: tWidth, y: 0 }, endPoint: { x: tWidth, y: tHeight - tStem }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-2`, startPoint: { x: tWidth, y: tHeight - tStem }, endPoint: { x: tWidth - tStem, y: tHeight - tStem }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-3`, startPoint: { x: tWidth - tStem, y: tHeight - tStem }, endPoint: { x: tWidth - tStem, y: tHeight }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-4`, startPoint: { x: tWidth - tStem, y: tHeight }, endPoint: { x: 0, y: tHeight }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-5`, startPoint: { x: 0, y: tHeight }, endPoint: { x: 0, y: 0 }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] }
            );
            break;

        default:
            // Default to rectangle
            walls.push(
                { id: `wall-${Date.now()}-0`, startPoint: { x: 0, y: 0 }, endPoint: { x: width, y: 0 }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-1`, startPoint: { x: width, y: 0 }, endPoint: { x: width, y: height }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-2`, startPoint: { x: width, y: height }, endPoint: { x: 0, y: height }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] },
                { id: `wall-${Date.now()}-3`, startPoint: { x: 0, y: height }, endPoint: { x: 0, y: 0 }, type: WALL_TYPES.REGULAR, doors: [], windows: [], electricityPoints: [] }
            );
    }

    return walls.map(wall => ({
        ...wall,
        length: calculateWallLength(wall)
    }));
}

export function calculateWallLength(wall) {
    const dx = wall.endPoint.x - wall.startPoint.x;
    const dy = wall.endPoint.y - wall.startPoint.y;
    return Math.sqrt(dx * dx + dy * dy);
}

export function computeOffsetOnWall(wall, point) {
    const ax = wall.startPoint.x;
    const ay = wall.startPoint.y;
    const bx = wall.endPoint.x;
    const by = wall.endPoint.y;

    const px = point.x;
    const py = point.y;

    const abx = bx - ax;
    const aby = by - ay;

    const apx = px - ax;
    const apy = py - ay;

    const abLenSq = abx * abx + aby * aby;
    if (abLenSq === 0) return 0; // degenerate wall

    let t = (apx * abx + apy * aby) / abLenSq;

    // clamp to segment
    t = Math.max(0, Math.min(1, t));

    const abLen = Math.sqrt(abLenSq);

    return t * abLen;
}